import { render } from "./RouterListLink.vue?vue&type=template&id=fd1451bc"
import script from "./RouterListLink.vue?vue&type=script&lang=js"
export * from "./RouterListLink.vue?vue&type=script&lang=js"
script.render = render

export default script